import * as React from 'react';
import cn from 'classnames';

import './index.scss';

interface Props {
  className?: string;
  value: number;
  max: number;
}

export const Bar: React.FC<Props> = ({ className, value, max }) => {
  return (
    <div
      className={cn('amount-input-bar', className)}
      style={{ width: `${Math.min(value / max, 1) * 100}%` }}
    />
  );
};
